import Swiper from 'swiper/js/swiper.min';

const anchorSliderElements = Array.from(document.querySelectorAll('.j-anchor-slider'));
const optionsAnchorList = {
    wrapperClass : 'j-anchor-container',
    slideClass   : 'j-anchor-slide',
    slidesPerView: 'auto'
};

let swiper = null;

const swiperStatus = function() {
    if (window.innerWidth < 960 && anchorSliderElements.length) {
        if (swiper) {
            swiper.forEach((element) => {
                return element.init();
            });
        } else {
            swiper = anchorSliderElements.map((element) => {
                return new Swiper(element, optionsAnchorList);
            });
        }
    } else if (swiper) {
        swiper.forEach((element) => {
            return element.destroy();
        });
        swiper = null;
    }
};

swiperStatus();

window.addEventListener('resize', () => {
    swiperStatus();
});
